import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rappider-ui-admin-pages',
  templateUrl: './ui-admin-pages.component.html',
  styleUrls: ['./ui-admin-pages.component.scss']
})
export class UiAdminPagesComponent implements OnInit {

  ngOnInit(): void {
    console.log('Component initialized.');
  }

}
